<template>
  <AppHeaderDropdown right no-caret>
    <template slot="header">
      {{ (userData.name) ? userData.name : currentUser.email}}
      <img :src="photo" class="fotoCard" :alt="currentUser.email" />
    </template>
    <template slot="dropdown">
      <b-dropdown-header
        tag="div"
        class="text-center">
        <strong>Opciones</strong>
      </b-dropdown-header>
      <b-dropdown-item to="/profile"><i class="fa fa-user" /> {{ $t("messages.profile") }}</b-dropdown-item>
      <!-- <b-dropdown-item><i class="fa fa-wrench" /> Settings</b-dropdown-item> -->
      <b-dropdown-divider />
      <b-dropdown-item @click="logout"><i class="fa fa-lock" /> {{ $t("messages.logout") }}</b-dropdown-item>
    </template>
  </AppHeaderDropdown>

</template>

<script>
import { HeaderDropdown as AppHeaderDropdown } from '@coreui/vue'
import { mapState } from 'vuex'
const fb = require('../firebaseConfig.js')
import image from "../assets/user_profile.png"

export default {
  name: 'DefaultHeaderDropdownAccnt',
  components: {
    AppHeaderDropdown
  },
  data: () => {
    return {
        photo: image
      }
  },
  computed: {
  ...mapState(['currentUser', 'userData', 'userImage'])
  },

  created(){
      this.$store.dispatch("fetchUserImage").then(image => {
         this.photo = image
      }, error=>{
        console.log(error)
          this.photo = this.currentUser.photoURL 
      })
  },
  methods:{
    logout() {
        fb.auth.signOut().then(() => {
            this.$store.dispatch('clearData')
            this.$router.push('/login')
        }).catch(err => {
            console.log(err)
        })
    }
  }
}
</script>

<style scoped>
  .fotoCard{border-radius:45px;border:1px solid #13b405;width:35px;height:35px;margin-right:12px;text-align:center;overflow:hidden;position: relative;object-fit:cover;
  }

</style>



// WEBPACK FOOTER //
// src/components/DefaultHeaderDropdownAccnt.vue